document.addEventListener('DOMContentLoaded', () => {
  const rangeEl = document.querySelector('.pe-delivery__range-dates');
  const countdownEl = document.querySelector('.pe-delivery__countdown-time');

  if (!rangeEl || !countdownEl) return;

  const now = new Date();

  function addBusinessDays(date, days) {
    const result = new Date(date);
    while (days > 0) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        days--;
      }
    }
    return result;
  }

  const start = addBusinessDays(now, 1);
  const end = addBusinessDays(now, 2);

  const options = { weekday: 'long', day: '2-digit', month: 'short' };

  rangeEl.textContent =
    `${start.toLocaleDateString('de-DE', options)} und ${end.toLocaleDateString('de-DE', options)}`;

  function updateCountdown() {
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);

    const diff = midnight - new Date();
    if (diff <= 0) return;

    const h = Math.floor(diff / 1000 / 60 / 60);
    const m = Math.floor((diff / 1000 / 60) % 60);
    const s = Math.floor((diff / 1000) % 60);

    countdownEl.textContent = `${h} Std. ${m} Min. ${s} Sek.`;
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
});
